import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/ThemeContext';
import Home from '@/pages/Home';
import Impact from '@/pages/Impact';
import Contact from '@/pages/Contact';
import About from '@/pages/About';
import Privacy from '@/pages/Privacy';
import HowWeWork from '@/pages/HowWeWork';
import Startup from '@/pages/Startup';
import Careers from '@/pages/Careers';
import SquareOneAlumni from '@/pages/SquareOneAlumni';
import SquareOneAlumniApply from '@/pages/SquareOneAlumniApply';
import Blueprint from '@/pages/Blueprint';
import Team from '@/pages/Team';
import DeveloperReady from '@/pages/DeveloperReady';
import AIAssessments from '@/pages/AIAssessments';
import CustomDashboards from '@/pages/CustomDashboards';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/portfolio" element={<Navigate to="/how-we-work" replace />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
            <Route path="/for-founders" element={<Navigate to="/startups" replace />} />
            <Route path="/startups" element={<Startup />} />
            <Route path="/technical-blueprint" element={<Blueprint />} />
            <Route path="/squareone-alumni" element={<SquareOneAlumni />} />
            <Route path="/squareone-alumni/apply" element={<SquareOneAlumniApply />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/team" element={<Team />} />
            <Route path="/developer-ready" element={<DeveloperReady />} />
            <Route path="/ai-assessments" element={<AIAssessments />} />
            <Route path="/custom-dashboards" element={<CustomDashboards />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
